import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { defineMessages, useIntl } from 'react-intl';
import './react-datepicker.css';
import leftKey from '@plone/volto/icons/left-key.svg';
import rightKey from '@plone/volto/icons/right-key.svg';
const ReactDatepickerWidget = (props) => {
  const { id, min = 1920, futureYears = 0, value, onChange } = props;
  const intl = useIntl();
  const NextIcon = (props) => (
    <div {...props} className="DayPickerNavigation_button ">
      <div
        style={{
          right: '22px',
          top: '15px',
        }}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex="0"
      >
        <Icon name={rightKey} size="30px" />
      </div>
    </div>
  );

  const PrevIcon = (props) => (
    <div {...props} className="DayPickerNavigation_button ">
      <div
        style={{
          left: '22px',
          top: '15px',
        }}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex="0"
      >
        <Icon name={leftKey} size="30px" />
      </div>
    </div>
  );

  const [year, setYear] = useState(
    value ? new Date(value).getFullYear() : new Date().getFullYear(),
  );
  const years = Array.from(
    { length: new Date().getFullYear() + futureYears + 1 - min },
    (_, i) => (min + i).toString(),
  );
  const messages = defineMessages({
    Monday: {
      id: 'Monday',
      defaultMessage: 'Mo',
    },
    Tuesday: {
      id: 'Tuesday',
      defaultMessage: 'Tu',
    },
    Wednesday: {
      id: 'Wednesday',
      defaultMessage: 'We',
    },
    Thursday: {
      id: 'Thursday',
      defaultMessage: 'Th',
    },
    Friday: {
      id: 'Friday',
      defaultMessage: 'Fr',
    },
    Saturday: {
      id: 'Saturday',
      defaultMessage: 'Sa',
    },
    Sunday: {
      id: 'Sunday',
      defaultMessage: 'Su',
    },
    January: {
      id: 'January',
      defaultMessage: 'January',
    },
    February: {
      id: 'February',
      defaultMessage: 'February',
    },
    March: {
      id: 'March',
      defaultMessage: 'March',
    },
    April: {
      id: 'April',
      defaultMessage: 'April',
    },
    May: {
      id: 'May',
      defaultMessage: 'May',
    },
    June: {
      id: 'June',
      defaultMessage: 'June',
    },
    July: {
      id: 'July',
      defaultMessage: 'July',
    },
    August: {
      id: 'August',
      defaultMessage: 'August',
    },
    September: {
      id: 'September',
      defaultMessage: 'September',
    },
    October: {
      id: 'October',
      defaultMessage: 'October',
    },
    November: {
      id: 'November',
      defaultMessage: 'November',
    },
    December: {
      id: 'December',
      defaultMessage: 'December',
    },
    placeholder: {
      id: 'yyyy-mm-dd',
      defaultMessage: 'yyyy-mm-dd',
    },
  });
  const months = [
    intl.formatMessage(messages.January),
    intl.formatMessage(messages.February),
    intl.formatMessage(messages.March),
    intl.formatMessage(messages.April),
    intl.formatMessage(messages.May),
    intl.formatMessage(messages.June),
    intl.formatMessage(messages.July),
    intl.formatMessage(messages.August),
    intl.formatMessage(messages.September),
    intl.formatMessage(messages.October),
    intl.formatMessage(messages.November),
    intl.formatMessage(messages.December),
  ];
  const weekdays = {
    Monday: intl.formatMessage(messages.Monday),
    Tuesday: intl.formatMessage(messages.Tuesday),
    Wednesday: intl.formatMessage(messages.Wednesday),
    Thursday: intl.formatMessage(messages.Thursday),
    Friday: intl.formatMessage(messages.Friday),
    Saturday: intl.formatMessage(messages.Saturday),
    Sunday: intl.formatMessage(messages.Sunday),
  };
  return (
    <DatePicker
      dateFormat="yyyy-MM-dd"
      placeholderText={intl.formatMessage(messages.placeholder)}
      formatWeekDay={(data) => {
        return weekdays[data];
      }}
      // isClearable
      calendarStartDay={1}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
      }) => (
        <div
          style={{
            margin: 10,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <PrevIcon onClick={decreaseMonth} />
          {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
          <select
            value={year}
            onChange={({ target: { value } }) => {
              changeYear(value);
              setYear(value);
            }}
          >
            {years.map((option) => (
              <option key={option} value={option} selected={option === year}>
                {option}
              </option>
            ))}
          </select>
          {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <NextIcon onClick={increaseMonth} />
        </div>
      )}
      selected={value ? new Date(value) : null}
      onChange={(date) => onChange(id, date.toISOString().slice(0, 10))}
    />
  );
};

export default ReactDatepickerWidget;
